import request from "@/utils/request";

// 获取一份题卡用于制作识别模板
export function getEventScheduleToken(id) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/eventSchedule/getEventScheduleTokenFormUrl?id=${id}`,
    method: "get",
  });
}
//  获取测试数据
export function getTestData() {
  return request({
    url: `https://testtk.ipmph.com/test-comp/admin/form/getTestData`,
    method: "get",
  });
}
